import React, { useRef } from 'react';
import { InputGroup, Input, InputRightElement } from '@chakra-ui/react';
import EmojiPickerButton from './EmojiPickerButton';

/**
 * Drop-in replacement for Chakra's <Input> with an emoji-picker button docked
 * inside the right edge, insert-at-cursor. For single-line fields — Push
 * Notification title, In-App header text, In-App footer.
 */
const EmojiInput = ({
    value,
    onChange,
    isReadOnly,
    disabled,
    maxLength,
    ...rest
}) => {
    const inputRef = useRef(null);

    const insertEmoji = (emoji) => {
        const input = inputRef.current;
        if (!input || isReadOnly || disabled) return;

        const start = input.selectionStart ?? value.length;
        const before = value.slice(0, start);
        const after = value.slice(start);
        const newText = before + emoji + after;

        if (maxLength && newText.length > maxLength) return;

        onChange({ target: { value: newText } });

        requestAnimationFrame(() => {
            input.focus();
            const pos = start + emoji.length;
            input.setSelectionRange(pos, pos);
        });
    };

    return (
        <InputGroup>
            <Input
                ref={inputRef}
                value={value}
                onChange={onChange}
                isReadOnly={isReadOnly}
                disabled={disabled}
                maxLength={maxLength}
                pr="2.5rem"
                {...rest}
            />
            <InputRightElement>
                <EmojiPickerButton onSelect={insertEmoji} isDisabled={isReadOnly || disabled} placement="top-end" />
            </InputRightElement>
        </InputGroup>
    );
};

export default EmojiInput;
